import React from 'react'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import "./SkeletonComponent.css"

const SkeletonComponent = ({ name }: any) => {

    return (
        <>
            {
                name === "VideoSection" && <div>
                    <div className='col-3'>
                        <Skeleton />
                    </div>
                    <div className='mt-5 row'>
                        <div className="col-12 col-lg-4  col-md-6  ">
                            <div className='p-5 shadow-sm rounded-2 Skeleton-effect'>
                            </div>
                        </div>
                        <div className="col-12 col-lg-4  col-md-6 my-4 my-md-0 my-lg-0">
                             <div className='p-5 shadow-sm  rounded-2 Skeleton-effect'>
                            </div>
                        </div>
                        <div className="col-12 col-lg-4  col-md-6 mt-md-4 mt-0 mt-lg-0 ">
                            <div className='p-5 shadow-sm  rounded-2 Skeleton-effect'>
                            </div>
                        </div>

                    </div>
                </div>
            }
            {
                name === "TopFaq" && <div className='row gap-3'>
                  {Array.from({ length: 3 }).map((_, index) => (
                    <div className="col-12" key={index}>
                        <Skeleton height={18} width={`${90 - index * 6}%`} />
                    </div>
                ))}

                </div>
            }

            {
                name === "Circulars" && <div className='d-flex flex-column gap-3'>
                  {Array.from({ length: 2 }).map((_, index) => (
                    <div
                        className={`d-flex align-items-start justify-content-between pb-3 gap-3 ${index === 1 ? '' : 'border-bottom'}`}
                        key={index}
                    >
                        <div style={{ flex: 1 }}>
                            <Skeleton height={18} width="95%" />
                            <Skeleton height={18} width="70%" />
                            <div className="mt-3 d-flex gap-2">
                                <Skeleton height={14} width={80} />
                                <Skeleton height={26} width={70} />
                                <Skeleton height={26} width={90} />
                            </div>
                        </div>
                        <Skeleton circle height={32} width={32} />
                    </div>
                ))}

                </div>
            }

			{name === "CategoryCard" &&  Array(6).fill(0).map((_, index) => (
				<div className="accordion-item border rounded-3 mb-3" key={index}>
					<div className="main-section-header-accordion d-flex align-items-center justify-content-between">
						<div className="d-flex align-items-center gap-2">
							<Skeleton circle height={32} width={32} />
							<Skeleton height={20} width={160} />
						</div>
						<Skeleton height={16} width={16} />
					</div>
				</div>
			))}
        </>
    )
}

export default SkeletonComponent